"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brandListApi = brandListApi;
exports.categoryApi = categoryApi;
exports.classifyList = classifyList;
exports.createSpec = createSpec;
exports.createSpecMultiLang = createSpecMultiLang;
exports.deleteSpec = deleteSpec;
exports.detailPage = detailPage;
exports.eColorBookList = eColorBookList;
exports.feeQuery = feeQuery;
exports.getBandApi = getBandApi;
exports.getByPage = getByPage;
exports.getCategoryApi = getCategoryApi;
exports.getDetailAPi = getDetailAPi;
exports.getReportApi = getReportApi;
exports.getSeasonApi = getSeasonApi;
exports.getUnitPage = getUnitPage;
exports.listNO = listNO;
exports.listSpec = listSpec;
exports.readSpec = readSpec;
exports.safeList = safeList;
exports.updateSpec = updateSpec;
exports.washingListNO = washingListNO;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestThree = _interopRequireDefault(require("@/utils/requestThree"));
// 商品规格
function listSpec(data) {
  return (0, _request.default)({
    url: '/spec/list',
    method: 'POST',
    data: data
  });
}
function createSpec(data) {
  return (0, _request.default)({
    url: '/spec/create',
    method: 'POST',
    data: data
  });
}
function createSpecMultiLang(data) {
  return (0, _request.default)({
    url: '/spec/createByMultiLang',
    method: 'POST',
    data: data
  });
}
function readSpec(data) {
  return (0, _request.default)({
    url: '/spec/read',
    method: 'POST',
    data: data
  });
}
function updateSpec(data) {
  return (0, _request.default)({
    url: '/spec/update',
    method: 'POST',
    data: data
  });
}
function deleteSpec(data) {
  return (0, _request.default)({
    url: '/spec/delete',
    method: 'POST',
    data: data
  });
}

//详情
function getDetailAPi(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/style/getByStyleNo',
    method: 'get',
    params: params
  });
}
// 季节
function getSeasonApi(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/dict/page',
    method: 'get',
    params: params
  });
}
// 波段
function getBandApi(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/band/list',
    method: 'get',
    params: params
  });
}
// 类目
function classifyList(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/classify',
    method: 'get',
    params: params
  });
}
function washingListNO(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/washing/list',
    method: 'get',
    params: params
  });
}
function getByPage(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/dict/page',
    method: 'get',
    params: params
  });
}
// 水洗列表

function listNO(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/base-management/list',
    method: 'get',
    params: params
  });
}
function getUnitPage(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/unit/page',
    method: 'get',
    params: params
  });
}
// 获取映射种类
function getCategoryApi(data) {
  return (0, _requestThree.default)({
    url: '/scm/app/category_size_type/list',
    method: 'post',
    data: data
  });
}
function categoryApi(data) {
  return (0, _requestThree.default)({
    url: '/scm/app/category_size_mapping/querySizeMapping',
    method: 'post',
    data: data
  });
}
// 获取平台收费
function feeQuery(data) {
  return (0, _requestThree.default)({
    url: '/scm/app/fee/query',
    method: 'post',
    data: data
  });
}
function detailPage(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/styleMallSku/detailPage',
    method: 'get',
    params: params
  });
}
function brandListApi(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/brand/list',
    method: 'get',
    params: params
  });
}
//获取安全类别数据
function safeList(params) {
  return (0, _requestThree.default)({
    url: '/scm/app/safe/list',
    method: 'get',
    params: params
  });
}
//电子色卡列表数据
function eColorBookList() {
  return (0, _requestThree.default)({
    url: '/scm/app/e_color_book/list',
    method: 'get'
  });
}
// 获取列表
function getReportApi(data) {
  return (0, _requestThree.default)({
    url: '/scm/app/test_report/listPage',
    method: 'post',
    data: data
  });
}